import type { SummaryTotals } from '../types';
import { fmtMoney } from '../lib/format';

export function SummaryCards({ totals }: { totals: SummaryTotals }) {
  const net = totals.revenue_cents + totals.expense_cents; // expense is negative
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <Card
        label="Revenue"
        value={fmtMoney(Math.abs(totals.revenue_cents))}
        hint={`${totals.tx_count} total transactions`}
        tone="positive"
      />
      <Card
        label="Expenses"
        value={fmtMoney(Math.abs(totals.expense_cents))}
        hint="Across all cards"
        tone="negative"
      />
      <Card
        label="Net"
        value={fmtMoney(net, { sign: true })}
        hint={net >= 0 ? 'In the black' : 'In the red'}
        tone={net >= 0 ? 'positive' : 'negative'}
      />
    </div>
  );
}

function Card({ label, value, hint, tone }: { label: string; value: string; hint: string; tone: 'positive' | 'negative' }) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-5">
      <div className="text-xs uppercase tracking-wide text-slate-500 font-semibold">{label}</div>
      <div className={`mt-2 text-3xl font-semibold tnum ${tone === 'positive' ? 'text-emerald-700' : 'text-rose-700'}`}>
        {value}
      </div>
      <div className="mt-1 text-sm text-slate-500">{hint}</div>
    </div>
  );
}
